import {DataCenter} from "./DataCenter";
import LoadingRT from "./LoadingRT";
import * as consts from "./play/const";
import * as Anim from "./play/Anim";
import { LanguageService } from "./play/Lang";
import * as Env from "./Env";

const { regClass, property } = Laya;

@regClass('e60XQm7tTY2BwFAdxb8D1g')
export class Main extends Laya.Script {
    static instance: Main = null;
    constructor() {
        super();
        Main.instance = this;
    }

    @property({ type: Laya.Texture })
    lang_cn: Laya.Texture;

    private _selectList: Laya.List;
    private _center: Laya.Sprite;
    private _share: Laya.Button;
    private _ranking: Laya.Button;
    private _rank_panel: Laya.Sprite;

    private _btn_start: Laya.Button; 
    private num : number = 0;

    private _listData: string[] = [];
    onAwake() {
        this._center = this.owner.getChildByName("center") as Laya.Sprite;
        this._share = this._center.getChildByName("Share") as Laya.Button;
        this._ranking = this._center.getChildByName("Ranking") as Laya.Button;

        this._btn_start = this._center.getChildByName("play") as Laya.Button;
        this._btn_start.label = LanguageService.instance.translate("level");
        let btn_select = this._center.getChildByName("select") as Laya.Button;
        btn_select.visible = false;

        this._btn_start.on(Laya.Event.CLICK, this, this.onPlayClick);
        btn_select.on(Laya.Event.CLICK, this, this.onSelectClick);

        let btn_collect = this._center.getChildByName("Collect") as Laya.Button;
        btn_collect.label = LanguageService.instance.translate("collect");
        btn_collect.on(Laya.Event.CLICK, this, this.onCollectClick);

        let btn_drop = this._center.getChildByName("Drop") as Laya.Button;
        btn_drop.label = LanguageService.instance.translate("xmas");
        btn_drop.on(Laya.Event.CLICK, this, this.onXmasClick);
        
        this._share.on(Laya.Event.CLICK, this, this.onShareClick);
        this._ranking.on(Laya.Event.CLICK, this, this.onRankingClick);

        this._selectList = this._center.getChildByName("List") as Laya.List;
        this._selectList.visible = false;
        this._selectList.on(Laya.Event.CLICK, this, this.onSelectLevel);

        this._rank_panel = this._center.getChildByName("rank_panel") as Laya.Sprite;
        this._rank_panel.visible = false;

        let lv = DataCenter.instance.level_info[consts.MODE_COMMON];
        let label = this._btn_start .getChildAt(0) as Laya.Label;
        label.text = "" + lv;
        DataCenter.instance.adjustScreen(this._center);

        for(let i = 0; i < DataCenter.instance.all_levels.length; i++) {
            this._listData.push("" + (i + 1));
        }
    }
    onStart() {
        console.log("Game start");
        //Anim.ScaleLoop(this._btn_start, 0.1, 1000, null);
    }

    private onSelectLevel(e: Laya.Event, index: number): void {
        if(e.target.dataSource == undefined) {
            return;
        }
            
        let idx = parseInt(e.target.dataSource);
        DataCenter.instance.free_mode = true;
        Main.startLevel(idx);
        //this._select_level = this._lv_data[idx];
    }

    private onShareClick() {
        
    }

    private onRankingClick() {
    }


    async onSelectClick() {
        this._selectList.dataSource = this._listData;
        this._selectList.visible = true;
    }

    async onPlayClick() {
        console.log("start");
        DataCenter.instance.free_mode = false;
        await LoadingRT.instance.StartMode(consts.MODE_COMMON);
    }
    async onCollectClick() {
        DataCenter.instance.free_mode = false;
        await LoadingRT.instance.StartMode(consts.MODE_COLLECT);
    }
    async onXmasClick() {
        DataCenter.instance.free_mode = false;
        await LoadingRT.instance.StartMode(consts.MODE_XMAS);
    }

    public static startLevel(level: number) {
        let DB = DataCenter.instance;
        DB.level_id = level;
        DB.level_data = DB.getLevelData(level);
        Laya.Scene.open("scenes/GamePlay.ls");
    }

    public updateDishItem(item: Laya.Box, index: number): void {
    }
}